import React from 'react';
import PropTypes from 'prop-types';
//COMPONENTS
import { CircularProgress, Dialog, DialogContent, DialogActions } from '@material-ui/core';
import AppBarModal from '../general/AppBarModal';
import ListarDatos from '../general/ListarDatos';
import { BtnForm } from '../general/BotonesAccion';
//MATERIAL
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import Typography from '@material-ui/core/Typography';
//MATERIAL ICONS
import AssignmentTurnedInRoundedIcon from '@material-ui/icons/AssignmentTurnedInRounded';
import HourglassEmptyRoundedIcon from '@material-ui/icons/HourglassEmptyRounded';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

// consultas/semaforo_new ya manda las materias agrupadas por semestre
// ({ "1": [...], "2": [...] }), con "materia"/"profesor" en vez de las
// posiciones crudas de fila que traia el endpoint viejo (consultas/semaforo).

const COLOR_SEMAFORO = { ok: '#639922', warn: '#ba7517', empty: '#b4b2a9' };

// Semaforo del semestre: verde si ya aprobo todo, ambar si le queda algo
// pendiente/no aprobada, gris si no tiene materias registradas.
function estadoSemestre(lista) {
  if (!lista || !lista.length) return 'empty';
  return lista.some((m) => m.estado !== 'Aprobada') ? 'warn' : 'ok';
}

function resumenSemestre(lista) {
  const total = (lista || []).length;
  if (!total) return 'Sin asignaturas';
  const pendientes = lista.filter((m) => m.estado !== 'Aprobada').length;
  const plural = total === 1 ? 'asignatura' : 'asignaturas';
  if (!pendientes) return `${total} ${plural} · todas aprobadas`;
  return `${total} ${plural} · ${pendientes} pendiente${pendientes === 1 ? '' : 's'}`;
}

const Semaforo = ({ status, toggle, data, cargando }) => {

  const materias = data || {};
  const semestres = Object.keys(materias).sort((a, b) => Number(a) - Number(b));

  // El semestre "actual" es el primero (mas antiguo) que aun tiene algo
  // pendiente; si todo esta aprobado, se abre el ultimo con datos.
  const semestreActual = semestres.find((i) => estadoSemestre(materias[i]) === 'warn')
    || semestres[semestres.length - 1];

  return (
    <Dialog open={status} onClose={() => toggle({ modal: 'dialogSemaforo', value: false })} aria-labelledby="form-dialog-title" fullWidth={true} maxWidth="sm">
      <AppBarModal titulo="Semaforo" mostrarModal={() => toggle({ modal: 'dialogSemaforo', value: false })} titulo_accion="" accion="" />
      <DialogContent style={{ padding: 0 }} className='scroll'>
        {cargando ? (
          <div style={{ padding: 60, textAlign: 'center' }}>
            <CircularProgress />
          </div>
        ) : (
        <div>
          {semestres.map((i) => {
            const estado = estadoSemestre(materias[i]);
            return (
              <ExpansionPanel square key={i} defaultExpanded={i === semestreActual}>
                <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                    <div
                      style={{
                        width: 8,
                        height: 8,
                        borderRadius: '50%',
                        backgroundColor: COLOR_SEMAFORO[estado],
                        flexShrink: 0,
                      }}
                    />
                    <div>
                      <Typography style={{ fontWeight: 700 }}>Semestre {i}</Typography>
                      <Typography variant="caption" style={{ color: '#62727b' }}>
                        {resumenSemestre(materias[i])}
                      </Typography>
                    </div>
                  </div>
                </ExpansionPanelSummary>
                <ListarDatos
                  id="tbl_listar_semaforo"
                  descargar="EMMA - SEMAFORO"
                  datos={materias[i]}
                  opciones={false}
                  agregar={false}
                  buscar={false}
                  acciones={{}}
                  avatar={({ estado }) => estado === "Aprobada" ? <AssignmentTurnedInRoundedIcon /> : <HourglassEmptyRoundedIcon />}
                  color_avatar={({ estado }) => estado === 'Aprobada' ? ({ 'backgroundColor': '#64dd17', 'color': '#ffffff' }) : ({ 'backgroundColor': '#ffd600', 'color': '#ffffff' })}
                  titulo={"Semaforo"}
                  fila_principal={({ materia }) => `${materia}`}
                  filas={[
                    {
                      'id': 'materia',
                      'enLista': false
                    },
                    {
                      'mostrar': ({ profesor }) => profesor ? `Profesor: ${profesor}` : '',
                      'id': 'profesor',
                      'enLista': true
                    },
                    {
                      'mostrar': ({ nota }) => `Nota: ${nota}`,
                      'id': 'nota',
                      'enLista': true
                    },
                  ]}
                />
              </ExpansionPanel>
            )
          })}
        </div>
        )}
      </DialogContent>
      <DialogActions>
        <BtnForm
          texto="Cerrar"
          variant="contained"
          color="#fff"
          callback={() => toggle({ modal: 'dialogSemaforo', value: false })}
        />
      </DialogActions>
    </Dialog>
  )
}

export default Semaforo
